// DS: i7.22
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorUndo = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.088 5.707a.992.992 0 000-1.414 1.02 1.02 0 00-1.43 0L4.795 7.12a.992.992 0 000 1.415l2.861 2.828a1.02 1.02 0 001.431 0 .992.992 0 000-1.414L8.128 9h4.797c2.514 0 4.552 2.015 4.552 4.5S15.439 18 12.925 18H10.25c-.558 0-1.011.448-1.011 1s.453 1 1.011 1h2.674c3.631 0 6.575-2.91 6.575-6.5S16.556 7 12.925 7H7.78l1.308-1.293z"
    })));
};
EditorUndo.displayName = 'EditorUndo';
export default EditorUndo;

//# sourceMappingURL=EditorUndo.js.map